import React, { useState } from 'react';

// Components
import * as S from './Styled';
import Spinner from '../Spinner';
import toast from '../../utils/toast';
import { useTranslation } from 'react-i18next';
import AddressAutocomplete from '../AddressAutocomplete';
import { fetchBrowserGeo } from '../../utils/map';

const ListOfCities = ({ handleSelectCity, location, visible }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleFetchBrowserGeo = async () => {
    try {
      setIsLoading(true);
      let data = await fetchBrowserGeo();
      handleSelectCity(data);
      setIsLoading(false);
    } catch (e) {
      toast.error({
        message: t('messages.errors.get_browser_error'),
        placement: 'bottomRight',
      });
      setIsLoading(false);
      console.error(e);
    }
  };

  return (
    <S.Wrapper>
      <S.Bg>
        <img src="/assets/svg/location.svg" alt={t('labels.location')} />
      </S.Bg>
      <S.List>
        <S.Title>
          {t('labels.you_are_shown_products_with_delivery_in_the_city')}&nbsp;
          <strong>{location?.name}</strong>
        </S.Title>
        {!isLoading ? (
          <>
            <S.ControlWrap>
              <AddressAutocomplete
                placeholder={t('labels.name_of_the_locality')}
                onSelect={item => handleSelectCity(item)}
                fetchBrowserGeo={handleFetchBrowserGeo}
                searchOptions={{ types: ['(cities)'] }}
                current={visible}
              />
            </S.ControlWrap>
            <S.ResetCity className="btn-link" onClick={handleFetchBrowserGeo}>
              {t('labels.detect_automatically')}
            </S.ResetCity>
          </>
        ) : (
          <Spinner />
        )}
      </S.List>
    </S.Wrapper>
  );
};

export default ListOfCities;
